declare namespace $ {

	type $mol_text__text_bog_pazzle_help_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	export class $bog_pazzle_help extends $mol_list {
		Rules( ): $mol_text
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=help.view.tree.d.ts.map